import { atom } from "recoil";

export const isFormSubmittedAtom = atom<boolean>({
  key: "isFormSubmittedAtom",
  default: false,
});
